import { Outlet, NavLink, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../store/authStore.jsx';
import { logout as apiLogout } from '../../api/auth';

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();

  async function handleLogout() {
    try { await apiLogout(); } catch { /* ignore */ }
    logout();
    navigate('/login');
  }

  const navItems = [
    { to: '/dashboard',  label: 'Dashboard' },
    { to: '/folders',    label: 'Folders' },
    { to: '/categories', label: 'Categories' },
    { to: '/upgrade',    label: 'Upgrade' },
    { to: '/settings',   label: 'Settings' },
    ...(user?.is_admin ? [{ to: '/admin', label: 'Admin' }] : []),
  ];

  const planLabel = ['', 'Free', 'Pro', 'Team', 'Enterprise'][user?.plan_id] ?? '';

  return (
    <div className="min-h-screen flex flex-col bg-gray-950">
      {/* Top nav */}
      <header className="border-b border-gray-800 bg-gray-900/80 backdrop-blur-sm sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between gap-4">
          <div className="flex items-center gap-6 min-w-0">
            <Link to="/dashboard" className="text-brand-400 font-bold text-lg tracking-tight shrink-0">
              Snapvault
            </Link>
            <nav className="hidden sm:flex items-center gap-1">
              {navItems.map(({ to, label }) => (
                <NavLink
                  key={to}
                  to={to}
                  className={({ isActive }) =>
                    `px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-brand-600/20 text-brand-400'
                        : 'text-gray-400 hover:text-gray-100 hover:bg-gray-800'
                    }`
                  }
                >
                  {label}
                </NavLink>
              ))}
            </nav>
          </div>

          <div className="flex items-center gap-3 shrink-0">
            <div className="hidden sm:flex flex-col items-end">
              <span className="text-sm text-gray-200 leading-none">{user?.display_name}</span>
              <span className="text-xs text-gray-500 mt-0.5">{planLabel}</span>
            </div>
            <button onClick={handleLogout} className="btn-secondary text-xs px-3 py-1.5">
              Sign out
            </button>
          </div>
        </div>
      </header>

      {/* Page content */}
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 py-6">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-800 py-4 text-center text-xs text-gray-600">
        Snapvault · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
